import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types';

const Types = {
	left: 'left',
	right: 'right',
	row: 'row',
} as const;

const displayNameByType = {
	[Types.left]: 'Left',
	[Types.right]: 'Right',
	[Types.row]: 'Row',
} as const;

const container = (type: keyof typeof Types) => {
	const Component = (props: Props) => (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		<div {...props} className={`${styles[type]} ${props.className || ''}`} />
	);

	return Object.assign(Component, { displayName: displayNameByType[type] });
};

export const Left = container(Types.left);
export const Right = container(Types.right);
export const Row = container(Types.row);
